<template>
  <div class="main-content">
    <div class="px-5 py-16 text-center">
      <p class="text-lg">Logging you out...</p>
    </div>
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "@/store";
import { authLogout } from "@/api/auth.js";

export default {
  setup() {
    const store = useStore();
    const router = useRouter();

    const logout = async () => {
      const refreshToken = store.state.auth.refreshToken;
      if (refreshToken) {
        try {
          await authLogout(refreshToken);
        } catch (error) {
          console.error("Logout request failed", error);
        }
      }
      await store.dispatch("auth/logout");
      router.replace({ path: "/login" });
    };

    onMounted(() => {
      logout();
    });

    return {};
  }
};
</script>
